import { useState, useEffect } from 'react';
import { getNetworkStatus, addNetworkStatusListener } from '../utils/capacitorNetwork';

/**
 * Custom hook to detect online/offline status
 * Uses Capacitor Network plugin when available, falls back to browser APIs
 * Returns current online status and connection type if available
 */
export function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);
  const [connectionType, setConnectionType] = useState('unknown');

  useEffect(() => {
    let unsubscribe = null;
    
    // Initialize network status
    getNetworkStatus().then((status) => {
      setIsOnline(status.connected);
      setConnectionType(status.connectionType);
    });

    // Set up network status listener
    addNetworkStatusListener((status) => {
      setIsOnline((prevIsOnline) => {
        const wasOnline = prevIsOnline;
        
        // Track if we were offline and just came back online
        if (!wasOnline && status.connected) {
          setWasOffline(true);
          // Reset wasOffline after a delay
          setTimeout(() => setWasOffline(false), 3000);
        }
        
        return status.connected;
      });
      setConnectionType(status.connectionType);
    }).then((unsub) => {
      unsubscribe = unsub;
    }).catch((error) => {
      console.error('Failed to set up network listener:', error);
    });

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);

  return { isOnline, wasOffline, connectionType };
}







